<template>
	<transition name="fade">
		<div v-if="visible" class="login-dialog">

			<div class="login_box loginSeries">
				<i class="iconfont icon-guanbi portal-login-iframe-close-icon" @click="portalLoginClose"></i>
				<div class="core" @click="operation">注册</div>
				<p class="title" style="margin-bottom: 61px;">账户登录</p>

				<ul class="userinfo">
					<li>
						<input type="text" placeholder="请输入您的手机号" v-model="loginForm.username" />
					</li>
					<li>
						<input type="password" placeholder="请输入您的密码" v-model="loginForm.password" />
						<i class="hint" v-if="!loginForm.show">{{loginForm.hint}}</i>
					</li>
				</ul>


				<button class="loginSeriesBtn buttonFill" @click="logo">登录</button>

				<p style="margin-top: 29px;font-size: 14px;color: #282828;cursor: pointer;" @click="forgetPassword">忘记密码</p>
			</div>



		</div>
	</transition>
</template>

<script>
	import publicMethod from '@/views/publicMethod'
	import qs from 'qs'
	import axios from 'axios'

	import {
		mapActions,
		mapMutations
	} from 'vuex'

	import {
		eventBus
	} from './eventBus.js';

	export default {
		name: 'LoginDialog',
		mixins: [publicMethod],
		data() {
			return {
				visible: false,
				loginForm: {
					username: '',
					password: '',
					show: true, //true 隐藏提示
					hint: '', //错误信息的提示语
					fromPath: '',
					query: {}
				},
				fromPath: '',
				additionalData: null,
				notReplace: false, //是否替换地址栏的地址  true:不替换   false:替换



			};
		},
		created() {
			// 订阅事件以显示登录对话框
			eventBus.$on('show-login-dialog', (fromPath, additionalData, notReplace) => {
				console.log('弹框接受登录-----------', fromPath, additionalData, notReplace)

				this.show(fromPath, additionalData, notReplace);
			});

			eventBus.$on('hide-dialog', () => {
				this.hide();
			});

		},
		mounted() {

		},
		methods: {
			...mapActions([
				'getUserInfo',
				'getIsLogining'
			]),
			show(fromPath, additionalData, notReplace) {
				this.visible = true;
				this.fromPath = fromPath;
				this.additionalData = additionalData;
				this.notReplace = notReplace

				document.body.style.overflow = 'hidden'
			},
			hide() {
				this.visible = false;
				document.body.style.removeProperty('overflow');
			},
			operation() {
				this.visible = false;
				document.body.style.removeProperty('overflow');

				eventBus.$emit('show-register-dialog');

				// window.location.reload();

				// console.log(this.$route)

				// this.$router.replace({
				// 	path: this.$route.fullPath
				// });

			},
			forgetPassword() {
				this.visible = false;
				document.body.style.removeProperty('overflow');

				eventBus.$emit('show-forgetPassword-dialog');
			},
			logo() {
				let _this = this;
				let phoneReg = /^[1][3,4,5,7,8,9][0-9]{9}$/; //电话
				let emailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/; //邮箱
				let type;
				if (this.loginForm.username == "") {
					this.loginForm.show = false;
					this.loginForm.hint = "请输入账户";
					return false
				} else if (this.loginForm.username.indexOf("@") == -1 && !phoneReg.test(this.loginForm.username)) {
					this.loginForm.show = false;
					this.loginForm.hint = "手机号输入有误";
					return false
				} else if (this.loginForm.username.indexOf("@") != -1 && !emailReg.test(this.loginForm.username)) {
					this.loginForm.show = false;
					this.loginForm.hint = "邮箱格式输入有误";
					return false
				} else if (this.loginForm.password == "") {
					this.loginForm.show = false;
					this.loginForm.hint = "请输入密码";
					return false
				} else {
					this.loginForm.show = true;
				}

				if (this.loginForm.username.indexOf("@") == -1) {
					type = 2;
				} else {
					type = 1;
				}

				this.$post(this.domain.dataRealization + 'dataCustomer/login', qs.stringify({
						loginName: this.loginForm.username,
						password: this.loginForm.password,
						type: type
					}))
					.then((res) => {
						// console.log(res.data)

						if (res.data.code == 200) {
							localStorage.setItem("userToken", res.data.token);
							localStorage.setItem("userName", this.loginForm.username);


							var data = {
								name: this.loginForm.username
							}
							this.getUserInfo({
								data
							})

							var isLogining = false
							this.getIsLogining({
								isLogining
							})

							this.updateAllComponents()


							console.log(this.fromPath)

							this.visible = false;
							document.body.style.removeProperty('overflow');

							if (this.fromPath) {
								if (this.notReplace) {
									this.$router.push({
										path: this.fromPath
									});
								} else {
									window.open(this.fromPath)
								}
							}


						} else {
							this.loginForm.show = false;
							this.loginForm.hint = res.data.message;
						}



					});

			},



		}
	};
</script>

<style scoped>
	@import "~@/assets/css/login/mask.less";

	.hint {
		position: absolute;
		left: 0;
		bottom: -20px;
		color: red;
	}
</style>